import type { ReactNode } from "react";
import type { AuthClient } from "../AuthClient";
import { authContext } from "./authContext";

interface AuthProviderProps {
  children: ReactNode;
  authClient: AuthClient;
  loginFallback: ReactNode;
}

export function AuthProvider({
  authClient,
  loginFallback,
  children,
}: AuthProviderProps) {
  return (
    <authContext.Provider value={{ client: authClient, loginFallback }}>
      {children}
    </authContext.Provider>
  );
}
